var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconIndustrialSite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 2.5H3M7 2.5V9.5M7 2.5H8M3 2.5V15C3 16.5 4.6 17.5 7 17.5H15C15.8333 17.5 17.5 17 17.5 15V7.91969C17.5 7.11066 16.5893 6.63748 15.9265 7.10142L12.5 9.5V7.46377C12.5 6.64648 11.5728 6.17433 10.9118 6.65503L7 9.5M3 2.5H2M7 15V9.5",
    stroke: "currentColor",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconIndustrialSite);
export default __webpack_public_path__ + "static/media/icon-industrial-site.7e8f4cd8d686ae4622f52a296e393e06.svg";
export { ForwardRef as ReactComponent };